// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

(function (M, Backbone, $, _) {
  'use strict';

  M.Collection = M.Collection || {};
  M.Collection.Browse = M.Collection.Browse || {};

  /**
   * @class BottomTrayItems
   *
   * A collection of M.Model.Browse.BottomTrayItem objects
   */
  M.Collection.Browse.BottomTrayItems = Backbone.Collection.extend({
    model: M.Model.Browse.BottomTrayItem,
    comparator: function(item) {
      return -item.get("index");
    },

    filterArtProductDuplicates: function() {
      return _.filter(this.models, function(item) {
        return !item.get('isArtProjectProduct');
      });
    }

  });

  var fetchDataError = function (url, response) {
    _serverLogger.error('returned error response for url ' + url, {'response': {'status' : response.status}});
  };

  var makeDataFetcher = function (ajaxOptions) {
    if (!ajaxOptions.url) {
      throw 'ajaxOptions must have a "url" property';
    }
    return function (cb, error) {
      var model = new M.Collection.Browse.BottomTrayItems();
      var deferred = $.ajax(_.extend({
        type: 'GET',
        dataType: 'json',
        success: function (response) {
          model.reset(response);
          cb && cb.apply(this, arguments);
        },
        error: function (response) {
          fetchDataError(ajaxOptions.url, response);
          error && error.apply(this, arguments);
        }
      }, ajaxOptions));
      return model;
    }
  };

  M.Collection.Browse.BottomTrayItems.fetchRecentlyViewed =
    makeDataFetcher({
      url: '/backbone/recently_viewed',
      // Adding this to avoid server side caching of results for IE
      cache: false
    });

  var emptyFavoritesFunction = function () {
    //in jtest some places are expecting M.Collection.Browse.BottomTrayItems.fetchFavorites
    //to be a function and not just an empty array
    return function (cb, error) {
      return new M.Collection.Browse.BottomTrayItems();
    }
  };

  M.Collection.Browse.BottomTrayItems.fetchFavorites = emptyFavoritesFunction();

})(M, Backbone, jQuery, _);

